export default __webpack_public_path__ + "static/error-500-88b492699e487a6c86c126ec71dd1000.png";